/* eslint-disable prettier/prettier */
import { Button, ButtonProps } from "@mui/material";
import { ChatIcon, VideoCallIcon } from "../../../utils/Icons";

interface ICommonButton extends ButtonProps {
  title: string;
  icon?: React.ReactElement;
  place?: string;
}

const CommonButton: React.FC<ICommonButton> = ({
  title,
  icon,
  place, // Optional: remove if not used
  onClick,
  disabled = false,
  color = "info",
  variant = "contained",
  sx,
  ...rest
}) => {
  const iconProps = {
    size: 21,
    color: variant === "contained" ? "white" : "",
    disabled
  };

  const getDefaultIcon = (): React.ReactElement | null => {
    if (icon) return icon;

    if (["Meeting", "Call"].includes(title)) return <VideoCallIcon {...iconProps} />;
    if (["Message", "Chat"].includes(title)) return <ChatIcon {...iconProps} />;

    return null;
  };

  return (
    <Button
      onClick={onClick}
      color={color}
      variant={variant}
      disabled={disabled}
      className="CommonButton-root fs-14"
      startIcon={getDefaultIcon()}
      sx={{ textTransform: "none", ...sx }}
      {...rest}
    >
      {title}
    </Button>
  );
};

export default CommonButton;
